export const compareStringWithAccent = (stringA, stringB) => {
  return (
    String(String(stringA).trim()).localeCompare(
      String(String(stringB).trim()),
      undefined,
      {
        sensitivity: 'base',
      }
    ) === 0
  )
}

export default { compareStringWithAccent }
